import Development from 'containers/Development';

export default function DevelopmentPage() {
  return (
    <div>
      <Development />
    </div>
  );
}
